module.exports = __webpack_public_path__ + "static/media/get_started_4.428efab2.png";